import {fv} from './utils'
import vMixin from '../components/_mixins/validation'

export const ValidationMixins = vMixin
export const Validators = require('vuelidate/lib/validators')
import { helpers } from 'vuelidate/lib/validators'

Validators.sameAsCI = (equalTo) =>
  helpers.withParams({ type: 'sameAsCI', eq: equalTo }, function(value, parentVm) {
    return (fv(value, '') + '').toLowerCase() === helpers.ref(equalTo, this, parentVm).toLowerCase()
  })

export const setValidationRule = (name, items, validator = 'submittingInvalidRule') => {
  if (!items) {
    items = _.startCase(name.replace(/^[\s\S]*\./, ''))
  }
  if (items && _.isString(items)) {
    items = {required: {error: `${items} is required.`}}
  }
  return {name, validator, items}
}

export const parseValidations = (validations) => {
  return _.reduce(validations, (items, item, key) => {
    items[key] = _.reduce(item.items, (v, ruleItem, ruleName) => {
      let {rule = Validators[ruleName]} = ruleItem
      _.set(v, ruleName, rule)
      return v
    }, {})
    return items
  }, {})
}

export const parseValidationSetup = (validations, vm) => {
  _.forOwn(validations, (item, key) => {
      if (!_.isFunction(item.validator)) {
        const validator = vm[item.validator]
        if (validator && _.isFunction(validator)) {
          item.validator = validator
        }

      }
  })
  return validations
}
export const truthyRule = Validators.sameAs(() => true )

export const passwordRules = {
  required: {error: 'Password is required.'},
  minLength: {
    error: 'Password has to be minimum of 8 characters.',
    rule: Validators.minLength(8)
  },
  hasAlpha: {
    error: 'Password must contain alphabets.',
    rule: Validators.helpers.regex('hasAlpha', /[a-zA-Z]/)
  },
  hasNum: {
    error: 'Password must contain a digit.',
    rule: Validators.helpers.regex('hasNum', /[0-9]/)
  },
  hasSym: {
    error: 'Password must contain a symbol.',
    rule: Validators.helpers.regex('hasSym', /[\W]/)
  },
  hasCap: {
    error: 'Password must contain a capital letter.',
    rule: Validators.helpers.regex('hasCap', /[A-Z]/)
  },
}

export const passwordConfirmationRules = {
  // required: {error: 'Confirm Password is required.'},
  sameAsPass: {error: 'Confirm Password needs to be same as Password.', rule: Validators.sameAs('password')},
}


export const emailConfirmationRules = {
  sameAsPass: {error: 'Confirm Email Address needs to be same as Email.', rule: Validators.sameAsCI('email')},
}

export const phoneConfirmationRules = {
  sameAsPass: {error: 'Confirm Mobile phone needs to be same as Mobile phone.', rule: Validators.sameAs('phone')},
}
